import * as t from 'io-ts';

import {makeEnumRuntimeType} from './apiTypes';
import {CommentStatusesEnum} from './commentModel';
import {MessageStatusesEnum, MessageTypesEnum, parseMessageType} from './messageModel';

/*
 * Runtime type.
 */

const RDraftSummaryDirty = t.readonly(
  t.type({
    id: t.Integer,
    authorId: t.union([t.Integer, t.undefined]),
    status: t.union([makeEnumRuntimeType(MessageStatusesEnum), makeEnumRuntimeType(CommentStatusesEnum)]),
    type: makeEnumRuntimeType(MessageTypesEnum),
    subject: t.union([t.string, t.undefined]),
    blurb: t.string,
    hasAttachments: t.boolean,
    isShared: t.boolean,
    updatedAt: t.union([t.Integer, t.undefined]),
  }),
);

/*
 * Type.
 */

export interface DraftSummaryModel extends t.TypeOf<typeof RDraftSummaryDirty> {}
export const RDraftSummary = t.clean<DraftSummaryModel>(RDraftSummaryDirty as any);

/*
 * IO methods.
 */

export function parseDraftSummary(src: any) {
  return {
    id: src.id,
    authorId: src.author_id,
    status: src.status,
    type: parseMessageType(src.type),
    subject: src.subject || undefined,
    blurb: src.blurb,
    hasAttachments: Boolean(src.has_attachments),
    isShared: Boolean(src.is_shared),
    updatedAt: src.updated_at,
  };
}
